module.exports = __webpack_public_path__ + "static/media/Averta-Semibold.8a953376.woff2";